import Vue from 'vue'
import axios from './vue-axios/axios'

export function getOffers(params){
  return Vue.axios.get(`${process.env.API_URL}/v2/offers`, {
    params: params,
    paramsSerializer: function(params) {
      return $.param(params)
    }
  })
}

export function countOffersByStatus(params){
  return Vue.axios.get(`${process.env.API_URL}/v1/offers/count_by_status`, {
    params: params,
    paramsSerializer: function(params) {
      return $.param(params)
    }
  })
}

export function downloadOffers(params) {
  return Vue.axios.get(`${process.env.API_URL}/v1/offers/export`, {
    params: { ...params, file_type: params['file_type'] },
    paramsSerializer: function(params) {
      return $.param(params);
    },
    responseType: 'arraybuffer'
  });
}

export function createOffer(offer, shouldBePublished, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList){
  let offerParams = {
    offer: processAttributes(offer),
    should_be_published: shouldBePublished,
    create_offers_for_each_period: createOffersByEachPeriod,
    managers_in_copy: managersToAddInCopy,
    potential_candidates_list: potentialCandidatesList
  }
  return axios.post(process.env.API_URL + '/v1/offers', offerParams)
}

export function getManagerInCopy(offer) {
  return Vue.axios.get('/v1/offers/' + offer.id + '/managers_in_copy')
}

export function getOffer(offerId){
  return Vue.axios.get('/v1/offers/' + offerId)
}

export function declineOffer(offerId, userAppliedOfferId){
  return Vue.axios.post(`/v1/offers/${offerId}/decline`, { user_apply_offer: { id: userAppliedOfferId }})
}

export function acceptOffer(offerId, userAppliedOfferId){
  return Vue.axios.post(`/v1/offers/${offerId}/accept`, { user_apply_offer: { id: userAppliedOfferId }})
}

export function deleteOffer(offerId){
  return Vue.axios.delete(`/v1/offers/${offerId}`)
}

export function cancelOffer(offerId, comment){
  return Vue.axios.put(`/v1/offers/${offerId}/cancel`, {comment: comment})
}

export function applyOffer(offerId){
  return Vue.axios.post('/v1/offers/' + offerId + '/apply')
}

export function refuseOffer(offerId){
  return Vue.axios.post('/v1/offers/' + offerId + '/refuse')
}

export function getNumberPotentialCandidates(params){
  return Vue.axios.post(process.env.API_URL + '/v1/candidates', params)
}

export function getPotentialCandidates(offer_params){
  return Vue.axios.post(process.env.API_URL + '/v1/candidates/potentials', offer_params)
}

export function getRefusedCandidatesCount(offerId){
  let url = process.env.API_URL + '/v1/offers/' + offerId + '/refused_candidates/count';
  return Vue.axios.get(url);
}

export function getRefusedCandidates(offerId){
  let url = process.env.API_URL + '/v1/offers/' + offerId + '/refused_candidates';
  return Vue.axios.get(url);
}

export function getSelectingCandidatesCount(offerId){
  return Vue.axios.get('/v1/offers/' + offerId + '/selecting_candidates/count')
}

export function getNumberOfRefutes(offerId){
  return Vue.axios.get(process.env.API_URL + '/v1/offers/' + offerId + '/refutes')
}

export function getCandidatesRefusingOffer(params) {
  return Vue.axios.get(process.env.API_URL + `/v1/offers/` + params['id'] + `/refusing_candidates`, { params: params,
    paramsSerializer: function(params) {
      return $.param(params)
    }
  })
}

export function getPotentialCandidatesWithoutRefutes(params) {
  return Vue.axios.get(process.env.API_URL + `/v1/offers/` + params['id'] + `/selecting_candidates`, { params: params,
    paramsSerializer: function(params) {
      return $.param(params)
    }
  })
}

export function updateOffer(offer, shouldBePublished, createOffersByEachPeriod, managersToAddInCopy, potentialCandidatesList){
  let updateOfferParams = {
    offer: processAttributes(offer),
    should_be_published: shouldBePublished,
    create_offers_for_each_period: createOffersByEachPeriod,
    managers_in_copy: managersToAddInCopy,
    potential_candidates_list: potentialCandidatesList
  }
  return axios.put(process.env.API_URL + '/v1/offers/' + offer.id, updateOfferParams)
}

export function updateAndRepublishOffer(offer, options, managersToAddInCopy, potentialCandidatesList){
  return Vue.axios.put(process.env.API_URL + '/v1/offers/' + offer.id + '/republish', { offer: processAttributes(offer),
                                                                                        options,
                                                                                        managers_in_copy: managersToAddInCopy,
                                                                                        potential_candidates_list: potentialCandidatesList })
}

// Permet d'envoyer des infos au backend afin de générer des logs lorsqu'un recruteur
//  valide le fait de publier une offre sans candidats selectionnés.
// Afin d'aider à élucider le mystère des offres sans candidats selectionné.
// À supprimer par la suite
export function postOfferLogs(action, offer) {
  return Vue.axios.post(
    `${process.env.API_URL}/v1/offers/logs`, {
      action: action,
      offer: offer
    });
}
// Logq end

function processAttributes(offer){
  offer.replaced_service_id = offer.replaced_service.id
  offer.replaced_occupation_id = offer.replaced_occupation.id
  offer.time_code_id = offer.time_code && offer.time_code.id
  offer.searched_occupation_ids = offer.searched_occupations.map(occupation => occupation.id)
  if (offer.replacement_motive) {
    offer.replacement_motive_id = offer.replacement_motive.id
  }
  offer.edit_comment = offer.edit_comment
  return offer
}

export function sendOfferToStaff(params) {
  return Vue.axios.put(process.env.API_URL + '/v1/offers/' + params['id'] + '/send_offer_to_staff', params)
}

export function canSendOfferToStaff(offer_id) {
  return Vue.axios.get(process.env.API_URL + '/v1/offers/' + offer_id + '/can_send_offer_to_staff')
}



// WEBPACK FOOTER //
// ./src/backend/offers.js